import styled from 'styled-components'
import { Link, colors, rgba, avatarBackground, radiuses } from 'styles'

const StyledMyAvatar = styled(Link)`
  text-decoration: none;

  .no-photo {
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    height: 6rem;
    padding: calc(50% - 3rem) 2rem;
    border-radius: ${radiuses.large};
    background-color: ${avatarBackground};
    font-size: 1.2rem;
    color: ${rgba(colors.main, 0.9)};
    text-transform: uppercase;
    font-weight: bold;
  }
`

export default StyledMyAvatar
